fragment URLFragment on URL {
  url
  site {
    id
    name
    icon
    highlighted
    category {
      id
      name
      sort_order
    }
  }
}
